// sessionStorage key prefix  for graphql API results cache
export const API_CACHE_PREFIX = 'API_CACHE'

// sessionStorage key prefix for graphql API results cache for batch queries
export const BATCH_CACHE_PREFIX = 'BATCH_CACHE'
